import moment from 'moment'

import { DateConfig } from 'components/Templates/Input/services/formatter'

const convertStartDate = (value: string | Date | moment.Moment) => {
  if (!value) return ''
  const startDate = DateConfig.to_BE_DateString(moment(value), {
    withTime: true,
    toUtc: true,
    adjust: 'startOfDay',
  })
  return startDate
}

const convertEndDate = (value: string | Date | moment.Moment) => {
  if (!value) return ''
  const endDate = DateConfig.to_BE_DateString(moment(value), {
    withTime: true,
    toUtc: true,
    adjust: 'endOfDay',
  })
  return endDate
}

const convertStartOfDay = (value: string | Date) => {
  if (!value) return ''
  const startDate = DateConfig.to_BE_DateString(moment(value).startOf('days'), {
    withTime: true,
  })
  return startDate
}

const convertEndOfDay = (value: string | Date) => {
  if (!value) return ''
  const endDate = DateConfig.to_BE_DateString(moment(value).endOf('days'), {
    withTime: true,
  })
  return endDate
}

export default {
  convertStartDate,
  convertEndDate,
  convertStartOfDay,
  convertEndOfDay,
}
